export default {
    api_url: process.env.VUE_APP_AS_API_URL,
    assets_url: process.env.VUE_APP_URL + "/static"
};
